module.exports = __webpack_public_path__ + "img/livro-jaleko-verde.7ddab05a.svg";